export const CONFIGURATION_REQUEST = 'CONFIGURATION_REQUEST';
export const CONFIGURATION_COMMIT = 'CONFIGURATION_COMMIT';
export const CONFIGURATION_SUCCESS = 'CONFIGURATION_SUCCESS';
